import React from 'react';
import styles from './JoinPageHome.module.scss';

const JoinPageHome = ({ children }) => {
  return <div className={styles.main_join_page_home}>{children}</div>;
};

export default JoinPageHome;
